export default "__VITE_ASSET__DulMy6dR__"